import { SVGProps } from 'react';
interface Props {
  title?: string;
  titleId?: string;
}
export const MessageIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & Props) => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6 flex-shrink-0 group-hover:text-gray-500" aria-hidden="true" aria-labelledby={titleId} {...props} data-sentry-element="svg" data-sentry-component="MessageIcon" data-sentry-source-file="message.tsx">
      {title ? <title id={titleId}>{title}</title> : null}
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" data-sentry-element="path" data-sentry-source-file="message.tsx"></path>
    </svg>;
};